<template>
<v-container class='input-text-size'>
    <CRUDCriteria :showReset="false" :showSearch="false" :showAdditionalActions="false">
      <template v-slot:criteriaRows>
        <div>
          <v-row dense>
            <v-col cols="3">
             <ClarionDateControl class="input-text-size ma-0 pa-0"
              :isToggle="false"
               :isRequired="false" :isIsoDate="false"
                v-model="criteriaState.businessdate"
                @blurred="searchByCriteria"
              label=" Business Date" />
            </v-col>
            <v-col cols="3" class="ma-0 pa-0 mt-3 ml-2">
            <SimpleMultiSelect
                id="tax-check-recon-criteria-wkst"
                label="Workstation #"
                :items="criteriaState.workstation || []"
                :item-list="wkstNumList"
                @selected-items="workStations"
                @blur="searchByCriteria"
              />
          </v-col >
            <v-col cols="3" class="ma-0 pa-0 mt-1 ml-2">
             <v-select class="input-text-size"
             label="Status"
             :items="approvalStatusData" v-model="criteriaState.approvalStatus"
             item-text="title"
             item-value="value"
             @change="searchByCriteria"></v-select>
            </v-col>
            <v-col cols='3' class='pt-2' v-if="isPaymentAdmin">
              <v-btn color="primary" dense small @click="handleApprovalStatus">
                          Approve
                        </v-btn>
            </v-col>
            <v-col cols='3' class='pt-2' v-else>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-btn color="primary" dense small disabled>
                      Approve
                    </v-btn>
                  </span>
                </template>
                <span>Only Payments Administrators can approve audits</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </template>
    </CRUDCriteria>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :headers='headers'
      :displayTopPagination="false"
      :canEdit="true"
      :canSave="true"
      :showDate="true"
      :showTotal="true"
      :baseCrudKey="baseCrudKey"
      :selectedItems="selectedItems"
      @emitSelectedItem="emitSelectedItem"
      @upsertItem="upsrtTransaction"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='250'
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      :defaultSortBy="sortBy"
      :showSelect="true"
      >
      <template v-slot:[`editedItem`]="{}">
        <auditRecord
      :baseCrudKey="baseCrudKey"
      :canApprove="isPaymentAdmin"
        />
      </template>
      </CRUDList>

    </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { paymentsAuditheaders } from '../paymentutils/PaymentTransactionTableHeaders';
import CRUDCriteria from '../../../common/base/crud-2.0/CRUDCriteria.vue';
import auditRecord from './auditRecord.vue';
import {
  // amountToNumber,
  defaultGridLoading, manageGridLoading,
} from '../../../../util/shared/vue-global';
import { makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import SimpleMultiSelect from '../../../common/base/SimpleMultiSelect.vue';
// import { getWorkstationNumber } from '../../../../util/workstation-util';
import { toIsoDate } from '../../../../util/shared/tmc-global';
import { isAuthorised } from '../../../../store/auth/token';
import { authRoles } from '../../../../router/roleGroups';

export default {
  name: 'audit',
  data() {
    return {
      headers: paymentsAuditheaders,
      selectedRows: [],
      selectedRow: null,
      gridLoading: defaultGridLoading(),
      selectedRowData: {},
      baseCrudKey: 'paymentAuditTransactionList',
      blockedOwnAuditCount: 0,
      approvalStatusData: [{
        title: 'Approved',
        value: true,
      }, {
        title: 'Unapproved',
        value: false,
      }],
      sortBy: [
        {
          column: 'paymentNumberAudit',
          direction: 'desc',
        },
      ],

    };
  },
  components: {
    CRUDList,
    CRUDCriteria,
    auditRecord,
    ClarionDateControl,
    SimpleMultiSelect,
  },
  created() {
    this.initCriteria();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'item',
    ]),
    ...mapState({
      storeSelItems: (state) => state.tax.taxPayment.selectedItems,
      wkstNumList: (state) => state.tax.taxPayment.wkstNumList || [],
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
    }),
    ...mapGetters('auth/token', [
      'authUser',
    ]),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    isPaymentAdmin() {
      return isAuthorised(authRoles.SuperAdmin) || isAuthorised(authRoles.PaymentAdmin);
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setCriteria']),
    ...mapMutations('tax/taxPayment', [
      'setSelectedItems',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPaymentAuditRecords',
      'upsertTaxPaymentAudit',
      'upsertTaxPaymentAudits',
      'loadWkstnList',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    initCriteria() {
      this.criteriaState = {};
      this.criteriaState.approvalStatus = false;
      this.loadConfig({ requiredScope: 'paymentConfig' });
      this.loadWkstnList({}).then(() => {
        this.criteriaState.workstation = this.wkstNumList;
        this.handleAuditRecords();
      });
    },
    async handleAuditRecords() {
      manageGridLoading(this, true, 'Searching...');
      const { baseCrudKey } = this;
      const criteria = {
        ...this.criteriaState,
        // eslint-disable-next-line operator-linebreak, max-len
        businessdate: this.criteriaState.businessdate ? toIsoDate(this.criteriaState.businessdate) : null,
      };
      await this.loadPaymentAuditRecords({
        criteria,
        baseCrudKey,
        postProcessTrans: this.postProcessData,
      }).then(() => {
        this.setDefaultSelectedItems();
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsrtTransaction(item) {
      const updatedauditRecordItem = { ...item };
      delete updatedauditRecordItem.approvalStatusForVisibility;
      const response = await this.upsertTaxPaymentAudit({
        item: updatedauditRecordItem,
        baseCrudKey: this.baseCrudKey,
      }).then(() => {
        this.handleAuditRecords();
      });
      return response;
    },
    preProcessForApproval(items) {
      const updatedItems = [];
      const { cannotApproveOwnAudit } = this.paymentSettingItem || {};
      this.blockedOwnAuditCount = 0;
      for (let i = 0; i < items.length; i += 1) {
        const item = { ...items[i] };
        if (item.approvalStatus) {
          // eslint-disable-next-line no-continue
          continue;
        }
        if (cannotApproveOwnAudit && item.user === this.authUser) {
          this.blockedOwnAuditCount += 1;
          // eslint-disable-next-line no-continue
          continue;
        }
        item.approvalStatus = true;
        delete item.approvalStatusForVisibility;
        updatedItems.push(item);
      }
      return updatedItems;
    },
    postProcessData(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        const item = {
          ...items[i],
        };
        item.approvalStatusForVisibility = item.approvalStatus === true ? 'Y' : 'N';
        updatedItems.push(item);
      }
      return updatedItems;
    },
    async handleApprovalStatus() {
      const items = this.selectedItems;
      if (!items || items.length === 0) return;
      const item = this.preProcessForApproval(items);
      if (this.blockedOwnAuditCount > 0) {
        alert(`${this.blockedOwnAuditCount} record(s) were not approved because you cannot approve your own audit.`);
      }
      if (item.length === 0) {
        if (this.blockedOwnAuditCount === 0) alert('All records are approved');
        return;
      }
      await this.upsertTaxPaymentAudits({
        item,
        baseCrudKey: this.baseCrudKey,
      }).then(() => {
        this.handleAuditRecords();
      });
    },
    workStations(val) {
      this.criteriaState.workstation = val;
      this.searchByCriteria();
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      const auditCriteria = { ...returnCriteria };
      this.criteriaState = auditCriteria;
      this.handleAuditRecords();
    },
  },
};
</script>
